<template>
  <div class="gantt-wrapper">
    <div class="gantt">
      <!-- Header de horas -->
      <div class="gantt__row gantt__row--months">
        <div class="gantt__row-first"></div>
        <span v-for="hour in displayHours" :key="hour">{{ hour }}</span>
      </div>

      <!-- Líneas verticales de referencia -->
      <div class="gantt__row gantt__row--lines" data-month="5">
        <template v-for="(time, index) in times">
          <span
            :key="index"
            v-bind:class="time.time"
          ></span>
        </template>
      </div>

      <!-- Filas de tarifa -->
      <template v-for="(tari, index) in listTarifas">
        <transition :key="index" name="slide-fade">
          <TarifaRow
            :key="index"
            :tarifa="tari"
            @successDelete="successDelete"
            :bus="bus"
          ></TarifaRow>
        </transition>
      </template>

      <!-- Estado vacío si no hay tarifas -->
      <div v-if="listTarifas.length === 0" class="gantt-empty">
        <span>No se encontraron tarifas para esta selección</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import TarifaRow from "./tarifaRow.vue"; 

export default {
  name: "tarifasTable",
  components: {
    TarifaRow,
  },
  props: ["tarifas", "bus"],
  data() {
    return {
      times: [],
      temporadas: [],
      displayHours: [
        "06:00", "07:00", "08:00", "09:00", "10:00", "11:00",
        "12:00", "13:00", "14:00", "15:00", "16:00", "17:00",
        "18:00", "19:00", "20:00", "21:00", "22:00", "23:00"
      ],
    };
  },
  methods: {
    buildTimesData() {
      let initTime = new moment("06:00", "HH:mm");
      let endTime = new moment("23:00", "HH:mm");
      let auxDate = initTime;
      this.times = [];
      this.times.push({ time: "00:00" });
      var i;
      for (i = 0; auxDate.format("HH:mm") <= endTime.format("HH:mm"); i++) {
        this.times.push({
          time: auxDate.format("HH:mm"),
        });
        auxDate = auxDate.add(10, "minutes");
      }
    },
    successDelete() {
      this.$emit("successDelete", true);
    },
    getTempordaById(code) {
      let itemIndex = this.$_.findIndex(this.temporadas, { id: code });
      if (itemIndex >= 0) {
        return this.temporadas[itemIndex];
      }

      return false;
    },
    async getTemporadas() {
      /* obtiene el listado de temporadas activas en el sistema  */
      const data = await this.$store.getters.getFirebaseApp.database
        .queryBuilder(
          "RVA/Tarifas/" +
            this.$store.getters.getIdDepartamentos.Golf +
            "/Temporadas"
        )
      if (!data.exists()) {
        return false;
      }
      let arrayTarifas = Object.entries(data.val());
      arrayTarifas.forEach((element) => {
        this.temporadas.push({ id: element[0], ...element[1] });
      });
    },
  },
  computed: {
    listTarifas() {
      let tarifas = this.tarifas;
      tarifas.forEach((tarifa) => {
        tarifa.arrayPrecios.forEach((modalidad) => {
          modalidad.horarios.sort(function compare(a, b) {
            return (
              moment(a.data.HoraInicio, "HH:mm") -
              moment(b.data.HoraInicio, "HH:mm")
            );
          });
          modalidad.horarios.forEach((horario) => {
            let indexStart = this.$_.findIndex(this.times, [
              "time",
              moment(horario.data.HoraInicio, "HH:mm:ss").format("HH:mm"),
            ]);
            let indexEnd = this.$_.findIndex(this.times, [
              "time",
              moment(horario.data.HoraTermino, "HH:mm:ss").format("HH:mm"),
            ]);
            horario.indexStart = indexStart;
            horario.indexEnd = indexEnd;
            horario.color =
              horario.PcoVen < 100
                ? "#3b82f6"
                : horario.PcoVen >= 150
                ? "#f59e0b"
                : "#10b981";
          });
        });
      });

      return tarifas;
    },
  },
  watch: {},
  mounted() {
    this.getTemporadas();
    this.buildTimesData();
  },
};
</script>

<style>
.gantt-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.gantt {
  display: grid;
  border: 0;
  position: relative;
  box-sizing: border-box;
  min-width: 900px;
}

.gantt__row {
  display: grid;
  grid-template-columns: 210px 1fr;
  background-color: #fff;
  transition: background-color 0.15s ease;
}

.gantt__row:nth-child(odd) {
  background-color: #f8fafc;
}

.gantt__row:nth-child(odd) .gantt__row-first {
  background-color: #f8fafc;
}

.gantt__row:nth-child(3) .gantt__row-bars {
  border-top: 0;
}

.gantt__row:nth-child(3) .gantt__row-first {
  border-top: 0;
}

.gantt__row--empty {
  background-color: #fef2f2 !important;
  z-index: 1;
}

.gantt__row--empty .gantt__row-first {
  border-width: 1px 1px 0 0;
}

/* Líneas verticales de referencia */
.gantt__row--lines {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: transparent;
  grid-template-columns: 210px repeat(108, 1fr);
}

.gantt__row--lines span {
  display: block;
  border-right: 1px solid rgba(0, 0, 0, 0.06);
}

.gantt__row--lines span.marker {
  background-color: rgba(10, 52, 68, 0.08);
  z-index: 2;
}

.gantt__row--lines:after {
  grid-row: 1;
  grid-column: 0;
  background-color: #1688b320;
  z-index: 2;
  height: 100%;
}

/* Header de horas */
.gantt__row--months {
  color: #f8fafc;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%) !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  grid-template-columns: 210px repeat(18, 1fr);
  position: sticky;
  top: 0;
  z-index: 5;
}

.gantt__row--months .gantt__row-first {
  border-top: 0 !important;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%) !important;
}

.gantt__row--months span {
  text-align: center;
  font-size: 0.72rem;
  align-self: center;
  font-weight: 600;
  padding: 0.9rem 0;
  border-right: solid 1px rgba(255, 255, 255, 0.1);
  letter-spacing: 0.3px;
}

/* Columna izquierda */
.gantt__row-first {
  background-color: #fff;
  border-width: 1px 0 0 0;
  border-color: rgba(0, 0, 0, 0.06);
  border-style: solid;
  padding: 0;
  font-size: 13px;
  font-weight: bold;
  text-align: center;
}

/* Barras de horario */
.gantt__row-bars {
  list-style: none;
  display: grid;
  padding: 8px 0;
  margin: 0;
  grid-template-columns: repeat(108, 1fr);
  grid-gap: 6px 0;
  border-top: 1px solid rgba(226, 232, 240, 0.8);
}

.gantt__row-bars li {
  min-height: 44px;
  max-height: max-content;
  font-weight: 600;
  text-align: left;
  font-size: 12px;
  background-color: #10b981;
  padding: 4px 10px;
  color: #fff;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  border-radius: 6px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.gantt__row-bars li:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.gantt__row-bars li.stripes {
  background-image: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 5px,
    rgba(255, 255, 255, 0.1) 5px,
    rgba(255, 255, 255, 0.1) 12px
  );
}

.gantt__row-bars li:before,
.gantt__row-bars li:after {
  content: "";
  height: 100%;
  top: 0;
  z-index: 4;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.15);
}

.gantt__row-bars li:before {
  left: 0;
}

.gantt__row-bars li:after {
  right: 0;
}

/* Estado vacío del gantt */
.gantt-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  color: #94a3b8;
  font-size: 0.85rem;
  font-weight: 500;
}

/* Transiciones */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>